module.exports = "<ng-content *ngIf=\"active\"></ng-content>"